import { typedQueryClient, useTypedMutation } from "hooks";
import { CheckInServicesQueryKeys } from "modules/CheckInServices/queryKeys";
import { ApiInstance } from "utils/Api";

type UpdateSendToLefPayload = {
  send_to_lef: boolean;
  lef_lead_kind: number | null;
  checkin_service_id: number;
  dealer_location_id: number;
};

export const useUpdateSendToLefMutation = () =>
  useTypedMutation<UpdateSendToLefPayload, void>({
    mutationFn: payload => ApiInstance.post("/check_in/service/update_send_to_lef", payload),
    onSuccess: payload => {
      const locationServices = typedQueryClient.getQueryData(CheckInServicesQueryKeys.locationList);
      if (!locationServices) return;

      const serviceIdx = locationServices.findIndex(service => service.id === payload.checkin_service_id);
      if (serviceIdx === -1) return;

      typedQueryClient.setQueryData(
        CheckInServicesQueryKeys.locationList,
        locationServices.with(serviceIdx, {
          ...locationServices[serviceIdx],
          send_to_lef: payload.send_to_lef,
          ...(payload.lef_lead_kind && { lef_lead_kind: payload.lef_lead_kind })
        })
      );
    }
  });
